import * as React from 'react'
import { PropsWithChildren } from 'react'
import { Stack } from '@fluentui/react'
import ActionButtons, { IActionButton } from '../ActionButtons'

type Props = PropsWithChildren<{
    actionButtonItems?: IActionButton[]
    actionButtonHorizontal?: boolean
}>

export default function ActionHeader(props: Props) {
    return (
        <div className="action-header">
            {props.actionButtonItems && (
                <div className="ms-Grid-col ms-sm12 ms-md5 ms-mdPush7 ms-lg4 ms-lgPush8">
                    <ActionButtons items={props.actionButtonItems} horizontal={props.actionButtonHorizontal} />
                </div>
            )}
            <div
                className={`ms-Grid-col ${
                    props.actionButtonItems ? 'ms-sm12 ms-md7 ms-mdPull5 ms-lg8 ms-lgPull4' : ''
                }`}
            >
                <Stack tokens={{ childrenGap: '4 8' }}>{props.children}</Stack>
            </div>
        </div>
    )
}
